import { createClient } from '@sanity/client';
import { createImageUrlBuilder } from '@sanity/image-url';

const projectId = import.meta.env.VITE_SANITY_PROJECT_ID || '';
const dataset = import.meta.env.VITE_SANITY_DATASET || 'production';

export const client = createClient({
  projectId,
  dataset,
  apiVersion: '2023-05-03', // stable api version
  useCdn: true, // true for cached edge queries
});

const builder = createImageUrlBuilder(client);
export function urlFor(source) {
  return builder.image(source);
}
